import React from "react";
import Nav from "../Navbar/Nav";
import { Box, Stack, Typography } from "@mui/material";
import Footer from "../utils/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Stack maxWidth={"1536px"} margin={"0 auto"}>
        <Nav />
        <Stack width={"100%"} alignItems={"center"}>
          <Box
            width={"100%"}
            height={"100%"}
            padding={{ xs: "20px 0px", md: "40px 0px" }}
            sx={{
              backgroundColor: "#00437A",
            }}
          >
            <Stack
              margin={"0 auto"}
              width={"80%"}
              height={"100%"}
              justifyContent={"center"}
              alignItems={"start"}
            >
              <Typography color={"white"} variant="h4" fontWeight={"bold"}>
                THIS PRIVACY POLICY APPLIES TO THE SANIIRO.COM
              </Typography>
            </Stack>
          </Box>

          <Stack
            width={"80%"}
            justifyContent={"center"}
            gap={3}
            marginTop={"30px"}
          >
            <Typography>
              Saniiro recognizes the importance of maintaining your privacy. We
              value your privacy and appreciate your trust in us. This Policy
              describes how we treat user information we collect on
              http://www.saniiro.com and other offline sources. This Privacy
              Policy applies to current and former visitors to our website and
              to our online customers. By visiting and/or using our website, you
              agree to this Privacy Policy. saniiro.com is a property of{" "}
              <b>Saniiro Technologies Private Limited</b>, an Indian Company
              registered under the Companies Act, 2013 having its registered
              office at 613-5th Floor Apex Mall Lalkothi, tonk road, Jaipur (
              rajasthan)- INDIA
            </Typography>
            <Stack>
              <Typography variant="h4" fontWeight={"bold"} color={"#00437A"}>
                Information we collect
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Contact information –</b> We might collect your name, email,
                mobile number, phone number, street, city, state, pincode,
                country and ip address.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Payment and billing information–</b> We might collect your
                billing name, billing address and payment method when you buy a
                subscription. We NEVER collect your credit card number or credit
                card expiry date or other details pertaining to your credit card
                on our website. Credit card information will be obtained and
                processed by our online payment partner payment gateway.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Information you post –</b> We collect information you post in
                a public space on our website or on a third-party social media
                site belonging to saniiro.com.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Demographic information–</b> We may collect demographic
                information about you, events you like, events you intend to
                participate in, tickets you buy, or any other information
                provided by your during the use of our website. We might collect
                this as a part of a survey also.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Other information –</b> If you use our website, we may
                collect information about your IP address and the browser you're
                using. We might look at what site you came from, duration of
                time spent on our website, pages accessed or what site you visit
                when you leave us. We might also collect the type of mobile
                device you are using, or the version of the operating system
                your computer or device is running.
              </Typography>
            </Stack>
            <Stack>
              <Typography variant="h4" fontWeight={"bold"} color={"#00437A"}>
                We collect information in different ways.
              </Typography>
            </Stack>

            <Stack>
              <Typography>
                <b>We collect information directly from you –</b> We collect
                information directly from you when you register for a trial or
                buy subscription. We also collect information if you post a
                comment on our websites or ask us a question through phone or
                email.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>We collect information from you passively –</b> We use
                tracking tools like Google Analytics, Google Webmaster, browser
                cookies and web beacons for collecting information about your
                usage of our website. We get information about you from third
                parties. For example, if you use an integrated social media
                feature on our websites. The third-party social media site will
                give us certain information about you. This could include your
                name and email address.
              </Typography>
            </Stack>
            <Stack>
              <Typography variant="h4" fontWeight={"bold"} color={"#00437A"}>
                Use of your personal information
              </Typography>
            </Stack>

            <Stack>
              <Typography>
                <b>We use information to contact you –</b> We might use the
                information you provide to contact you for confirmation of a
                purchase on our website or for other promotional purposes.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We use information to respond to your requests or questions. We
                might use your information to confirm your registration for an
                event or contest.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We use information to improve our products and services. We
                might use your information to customize your experience with us.
                This could include displaying content based upon your
                preferences.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We use information to look at site trends and customer
                interests. We may use your information to make our website and
                products better. We may combine information we get from you with
                information about you we get from third parties.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We use information for security purposes. We may use information
                to protect our company, our customers, or our websites.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We use information for marketing purposes. We might send you
                information about special promotions or offers. We might also
                tell you about new features or products. These might be our own
                offers or products, or third-party offers or products we think
                you might find interesting. Or, for example, if you buy
                subscription from us we'll enroll you in our newsletter.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We use information to send you transactional communications. We
                might send you emails or SMS about your account or a
                subscription purchase.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We use information as otherwise permitted by law.
              </Typography>
            </Stack>
            <Stack>
              <Typography>Sharing of information with third-parties</Typography>
            </Stack>
            <Stack>
              <Typography>
                We will share information with third parties who perform
                services on our behalf. We share information with vendors who
                help us manage our online registration process or payment
                processors or transactional message processors. Some vendors may
                be located outside of India.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We will share information with the event organizers. We share
                your information with event organizers and other parties
                responsible for fulfilling the purchase obligation. The event
                organizers and other parties may use the information we give
                them as described in their privacy policies.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We will share information with our business partners. This
                includes a third party who provide or sponsor an event, or who
                operates a venue where we hold events. Our partners use the
                information we give them as described in their privacy policies.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We may share information if we think we have to in order to
                comply with the law or to protect ourselves.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We will share information to respond to a court order or
                subpoena. We may also share it if a government agency or
                investigatory body requests. Or, we might also share information
                when we are investigating potential fraud.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We may share information with any successor to all or part of
                our business. For example, if part of our business is sold we
                may give our customer list as part of that transaction.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We may share your information for reasons not described in this
                policy.
              </Typography>
            </Stack>
            <Stack>
              <Typography>We will tell you before we do this.</Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Email Opt-Out</b> You can opt out of receiving our marketing
                emails. To stop receiving our promotional emails, please email
                unsubscribe@saniiro.com, It may take about ten days to process
                your request. Even if you opt out of getting marketing messages,
                we will still be sending you transactional messages through
                email and SMS about your purchases.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Third party sites</b> If you click on one of the links to
                third party websites, you may be taken to websites we do not
                control. This policy does not apply to the privacy practices of
                those websites. Read the privacy policy of other websites
                carefully. We are not responsible for these third party sites.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>To provide Community and Feedback</b> We provide discussion
                forums, blogs and other community–oriented features that enable
                forum members to communicate with other members. To participate
                in the forum, we require you to register with a valid e–mail
                address. We recommend that you exercise discretion in posting
                personal information on these message boards. Any information
                you provide is accessible by other users. We also have many
                places where users can provide feedback and suggestions. It is
                optional to provide your personal information. These submissions
                are not confidential or proprietary, and we may publish this
                information in a way that does not identify you personally.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                Some of our marketing emails have a "Refer–a–Friend" feature
                that provides you with the ability to automatically send
                information about saniiro Products and Services to your Friends.
                Your friend’s e–mail address will only be used for the one–time
                distribution of the information and will not be used for any
                other purpose.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                We offer various Internet chat services. We encrypt our Internet
                chat sessions and retain a transcript of the session to help us
                resolve your current and potential future questions.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Grievance Officer</b>
              </Typography>
              <Typography>
                In accordance with Information Technology Act 2000 and rules
                made there under, the name and contact details of the Grievance
                Officer are provided below: Mr. Praveen
              </Typography>
              <Typography>
                <b>Mr. Praveen</b>
              </Typography>
              <Typography>
                If you have any questions about this Policy or other privacy
                concerns, you can also email us at support@saniiro.com
              </Typography>
              <Typography>
                <b>
                  Address: 613, 5th floor, Apex mall, Lal kothi, Jaipur 302015
                  (India) Phone: +91-9460021200 Email: praveens@saniiro.com
                </b>
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Third party sites</b> If you click on one of the links to
                third party websites, you may be taken to websites we do not
                control. This policy does not apply to the privacy practices of
                those websites. Read the privacy policy of other websites
                carefully. We are not responsible for these third party sites.
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Updates to this policy</b>
              </Typography>
              <Typography>
                This Privacy Policy was last updated on “31/03/2020”. From time
                to time we may change our privacy practices. We will notify you
                of any material changes to this policy as required by law. We
                will also post an updated copy on our website. Please check our
                site periodically for updates.
              </Typography>
            </Stack>
            <Stack marginBottom={"30px"}>
              <Typography>
                <b>Jurisdiction</b>
              </Typography>
              <Typography>
                If you choose to visit the website, your visit and any dispute
                over privacy is subject to this Policy and the website's terms
                of use. In addition to the foregoing, any disputes arising under
                this Policy shall be governed by the laws of India.
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
